import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { reasonProblem } from '../../org/api-keys/key-words'
import { revokeKey } from './packages-api'

// Revokes a publish key (can't be undone), with an optional reason.
export const RevokeKeyDialog = ({ packageName, keyRow, onCancel, onRevoked }) => {
  const reasonId = useId()
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const cancel = () => { setError(null); onCancel() }
  const revoke = async () => {
    if (busy || !keyRow) return
    const problem = reasonProblem(reason)
    if (problem) return setError(problem)
    setBusy(true)
    setError(null)
    try {
      await revokeKey(packageName, keyRow.id, { reason: reason.trim() })
      setBusy(false)
      setReason('')
      onRevoked()
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The key couldn't be revoked."), err)
    }
  }

  return (
    <ConfirmDialog open={Boolean(keyRow)} title={keyRow ? `Revoke "${keyRow.name}"?` : ''}
      body="CI can no longer publish with this key. This can't be undone: create a new key to replace it."
      confirmText="Revoke key" busy={busy} error={error} failure={failure} onConfirm={revoke} onCancel={cancel}>
      <div className="mb-3">
        <label className="sw-label" htmlFor={reasonId}>Reason (optional)</label>
        <textarea id={reasonId} className="form-control" rows={2} maxLength={600} value={reason} onChange={e => setReason(e.target.value)} />
      </div>
    </ConfirmDialog>
  )
}
